import { useEffect, useState, forwardRef } from 'react';
import axios from 'axios';
import { CSVLink } from "react-csv";
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './ContributeAdmin.css';

const ContributeAdmin = () => {
    const [contributorsDetail, setContributorsDetail] = useState([]);
    const [contributorsDataForDownload, setContributorsDataForDownload] = useState([]);

    const [fromStartDate, setFromStartDate] = useState(new Date("2022/05/01"));    
    const [toEndDate, setToEndDate] = useState(new Date());    

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button className="date-picker-input-btn" onClick={onClick} ref={ref}>
          {value}
        </button>
    ));

    const handleStartDate = (date) => {        
        setFromStartDate(date)   
        let startDate = Moment(date).format('YYYY-MM-DD');
        let endDate = Moment(toEndDate).endOf('month').format('YYYY-MM-DD');                         
        fetchFilteredAPI(startDate, endDate);        
    }

    const handleEndDate = (date) => {                
        setToEndDate(date)        
        let startDate = Moment(fromStartDate).format('YYYY-MM-DD');
        let endDate = Moment(date).endOf('month').format('YYYY-MM-DD');                
        fetchFilteredAPI(startDate, endDate);        
    }
    
    const handleContributeDownload = () => {        
        let updatedDownloadData = contributorsDataForDownload.map((contributor, idx) => {            
                return {                
                    'SL#': idx + 1,
                    'Enterprise Id': contributor.enterprice_id,
                    'Career Level': contributor.career_level,
                    'Market': contributor.market,
                    'Market Unit': contributor.market_unit,                                
                    'Contribute': contributor.contribute,
                    'Contribute Other': contributor.contribute_other,
                    'Capability': contributor.capability,
                    'Capability Other': contributor.capability_other,
                    'Skill': contributor.skill,
                    'Contribute Date': `${Moment(contributor.created_at).format('DD-MM-YYYY')}`,                                
                };
            })        
        setContributorsDataForDownload(updatedDownloadData);
    }
    
    const fetchData = async () => {        
        try {
                let response = await axios({
                    method: 'get',                    
                    url: 'https://atci.lkm.accenture.com/lkm-apis/contribute',                                        
                    headers: {
                        'Authorization': localStorage.getItem("token"),
                        'Content-Type': 'application/json'
                    },
                })                                  
            setContributorsDetail(response.data.results);
            setContributorsDataForDownload(response.data.results);
        } catch(error) {
            console.log(error);
        }        
    }

    const fetchFilteredAPI = async (startDate, endDate) => {
        try {
                let response = await axios({
                    method: 'get',
                    url: `https://atci.lkm.accenture.com/lkm-apis/contribute/${startDate}/${endDate}`,
                    headers: {
                        'Authorization': localStorage.getItem("token"),
                        'Content-Type': 'application/json'
                    },                                         
                })                                     
                setContributorsDetail(response.data.results);
                setContributorsDataForDownload(response.data.results);
        } catch(error) {
            // console.log(error);
        }        
    }

    useEffect(() => {
        fetchData();
    },[]);

    return(
        <div className='contribute-admin'>
            <h2>L&TT Contribution requests</h2>
           <div className='main-content'>
                <div className='header-container'>                                                     
                        <div className='date-picker-container'>
                            <span className='filter-text'>Filter | &nbsp;</span>
                            <div className='date-picker-start'>                    
                                <DatePicker
                                    selected={fromStartDate}
                                    onChange={(date) => handleStartDate(date)}                                    
                                    minDate={new Date("2022/05/01")}
                                    maxDate={toEndDate}
                                    showMonthYearPicker
                                    dateFormat="MM, yyyy"
                                    customInput={<DatePickerInput/>}
                                />
                            </div>
                            <span className='filter-text'> &nbsp;&nbsp;to&nbsp;&nbsp; </span> 
                            <div className='date-picker-end'> 
                                <DatePicker
                                    selected={toEndDate}
                                    onChange={(date) => handleEndDate(date)}                                    
                                    minDate={fromStartDate}
                                    maxDate={new Date()}  
                                    showMonthYearPicker
                                    dateFormat="MM, yyyy"
                                    customInput={<DatePickerInput/>}
                                />
                            </div>    
                        </div>                                                            
                        {contributorsDataForDownload.length > 0 && <div className='lkm-contribute-download'>                
                            Feedback |&nbsp;
                            <CSVLink filename={"lkm-contributors.csv"} data={contributorsDataForDownload} onClick={handleContributeDownload}>Download</CSVLink>
                        </div>}                                                                                             
                </div>                         
                <table>
                <thead>
                    <tr>
                        <th>SL#</th>
                        <th>Enterprise Id</th>
                        <th>Career Level</th>
                        <th>Market</th>
                        <th>Market Unit</th>
                        <th>Contribute</th>
                        <th>Contribute (other)</th>
                        <th>Capability</th>
                        <th>Capability (other)</th>
                        <th>Skill</th>
                        <th>Request raised date</th>
                    </tr>                                                
                </thead>    
                <tbody>                                                    
                {contributorsDetail.length > 0 ? contributorsDetail.map((contributor, idx) => {                                                  
                    return <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{contributor.enterprice_id}</td>
                        <td>{contributor.career_level}</td>
                        <td>{contributor.market}</td>
                        <td>{contributor.market_unit !== '' ? contributor.market_unit : '-'}</td>
                        <td>{contributor.contribute}</td>
                        <td>{contributor.contribute_other !== '' ? contributor.contribute_other : '-'}</td>
                        <td>{contributor.capability !== '' ? contributor.capability : '-'}</td>
                        <td>{contributor.capability_other !== '' ? contributor.capability_other : '-'}</td>
                        <td>{contributor.skill !== '' ? contributor.skill : '-'}</td>
                        <td>{Moment(contributor.created_at).format('DD-MM-YYYY')}</td>
                    </tr>
                }) : <tr><td colspan="11">No Contributors Detail Found </td></tr>}                            
                </tbody>
            </table>
            </div> 
        </div>        
    )
}

export default ContributeAdmin;